export default __webpack_public_path__ + "static/aiCRMHeroBg-98e7c0e766584ed02a613fde88feef92.png";